import fetch from 'isomorphic-fetch';
import ENV from '../environments/environment';

const authService = {

   async loginEmail(form) {
     form = JSON.stringify(form);
     const response = await fetch(`${ENV.lupita_url}users/login/` , { headers: ENV.getLupitaHeaders() ,  method: "POST", body: form });
     return await response.json();
   },

    async loginFb(userData, accessToken) {
    var  form = {
        accessToken: accessToken,
        client_id: ENV.client_id,
        client_secret: ENV.client_secret,
        email: userData.email,
        first_name: userData.first_name,
        gender:"m",
        global_phone_number:"+57",
        identification:11111111,
        identification_type:1,
        last_name: userData.first_name,
        phone:"",
        phone_access_token:null,
        replacement_criteria_id:"replace",
        scope:"all",
        sms_code:"",
        social_id: userData.id,
        validate_code:false
      }
     form = JSON.stringify(form);
    const response =  await fetch(  ENV.getGrabilityUrl() + "login/facebook" , { headers: {'Content-Type':  'application/json'} ,  method: "POST", body: form })
    return await response.json();
   },

   async registerFb(userData, accessToken) {
   var  form = {
       accessToken: accessToken,
       client_id: ENV.client_id,
       client_secret: ENV.client_secret,
       email: userData.email,
       first_name: userData.first_name,
       gender:"m",
       global_phone_number:"+57",
       identification:11111111,
       identification_type:1,
       last_name: userData.first_name,
       phone: userData.phone,
       phone_access_token:null,
       replacement_criteria_id:"replace",
       scope:"all",
       sms_code:"",
       social_id: userData.id,
       validate_code:false
     }
     form = JSON.stringify(form);
   const response =  await fetch( ENV.getGrabilityUrl() + "web/register/facebook" , { headers: {'Content-Type':  'application/json'} ,  method: "POST", body: form })
   return await response.json();
 } ,


  async  sendSMS(phone,countryCode) {
    if(countryCode === '+52') {
      countryCode = countryCode + '1'
    }
     phone = countryCode + phone;
     let data =   {
          "identity": {
            "type": "number",
            "endpoint":  phone
          },
          "method": "sms",
          "metadata": {
            "os": "rest",
            "platform": "N/A"
          }
        }
      const response =  await fetch( ENV.sinch_url + "verifications" , { headers: ENV.getSinchHeaders() ,  method: "POST", body: JSON.stringify(data) })
      return await response.json();
    },

    async  verifyCode(code, countryCode , phone ) {
      if(countryCode === '+52') {
        countryCode = countryCode + '1'
      }
       let data = {
         "source": "manual",
           "sms": {
             "code": code
           },
           "method": "sms"
       }
       const response =  await fetch(ENV.sinch_url + "verifications/number/"  + countryCode + phone  , { headers: ENV.getSinchHeaders() ,  method: "PUT", body: JSON.stringify(data) })
       return await response.json();
     },

     async getToken(user) {
       let data = {
       user:
           {
           email: user.email,
           pass: user.password,
           id: user.id
          }
       }

       data = JSON.stringify(data);
       const response = await fetch(`${ENV.lupita_url}users/token/` , { headers: ENV.getLupitaHeaders() ,  method: "POST", body: data });
       return await response.json();
     }


}

export default authService;



// WEBPACK FOOTER //
// ./src/services/auth.service.js